export default [
// {
//     path: 'yxljProduct',
//     name: {list:['品质评价','产品','产品管理','链接产品']},
//     component: () => import('@/views/digitalBase/yxljProduct.vue')
// },
// {
//     path: 'pzpjManage',
//     name: {list:['品质评价','产品','产品管理','评价管理']},
//     component: () => import('@/views/digitalBase/pzpjManage.vue')
// },
{
    path: 'cpxxSettings',
    name: {list:['品质评价','产品','产品管理','产品信息设置']},
    component: () => import('@/views/digitalBase/cpxxSettings.vue')
},
]